import { cleanUrlComponent } from '@lib/helpers/client'

const getLocationString = (city: string, secondParam: string | undefined): string => {
  const cityString = cleanUrlComponent(city)
  const secondParamString = secondParam ? cleanUrlComponent(secondParam) : secondParam
  return secondParamString ? `${cityString},${secondParamString}` : cityString
}

export default getLocationString
